import React from "react";
import { useTheme } from "styled-components";
import * as StyledNav from "../Styled.Nav";

const LogoStan = ({ fill }) => {
  const theme = useTheme();
  return (
    // <StyledNav.Logo
    //   xmlns="http://www.w3.org/2000/svg"
    //   fillRule="evenodd"
    //   strokeLinejoin="round"
    //   strokeMiterlimit="2"
    //   clipRule="evenodd"
    //   viewBox="0 0 218 82"
    //   fill={theme.colors.imperialRed}
    // >
    //   <path d="M24.81 43.412h24.118l-3.877 14.47H20.932a11.101 11.101 0 01-10.725-13.977l8.882-33.144A14.517 14.517 0 0133.112 0h3.33L24.81 43.412zm61.76-14.471h-4.824l3.878-14.47h4.823L94.325 0h14.47l-3.877 14.471h14.471l-3.878 14.47h-14.47l-3.878 14.471h19.294l4.01-14.964a18.857 18.857 0 0118.216-13.977H162.8l-7.754 28.941h9.647l7.754-28.941h24.118a11.102 11.102 0 0110.725 13.977l-4.009 14.964h14.47l-13.524 14.47h-13.229a4.655 4.655 0 01-4.495-5.858l6.185-23.083h-9.647l-7.755 28.941h-14.471l1.939-7.235-6.762 7.235h-14.153a3.946 3.946 0 01-3.811-4.966l.608-2.269-6.762 7.235h-13.079a4.77 4.77 0 01-4.607-6.003l.977-3.644-12.232 9.647h-9.648A11.101 11.101 0 0182.56 43.905l4.01-14.964zm48.235 0l-3.877 14.471h9.647l3.877-14.471h-9.647zm-78.122-14.47l-5.17 19.294H37.042L46.089 0h38.589L80.8 14.471H56.683zM48.235 82H0l3.877-14.471h48.236l11.632-43.411A11.102 11.102 0 0174.47 38.095l-8.019 29.928A18.858 18.858 0 0148.235 82zm163.054-14.471L207.412 82H67.529l3.878-14.471h139.882z"></path>
    // </StyledNav.Logo>
    <StyledNav.Logo
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      strokeLinejoin="round"
      strokeMiterlimit="2"
      clipRule="evenodd"
      viewBox="0 0 532 200"
      fill={theme.colors.imperialRed}
    >
      <g transform="translate(-274.449 -440)">
        <path
          id="Stan"
          d="M1733.33 1641.73h118.11l-18.99 70.87h-118.11a54.35 54.35 0 0 1-43.14-21.28 54.39 54.39 0 0 1-9.39-47.17l43.5-162.32c8.32-31.08 36.49-52.7 68.67-52.7h16.31zm302.45-70.86h-23.62l18.99-70.87h23.62l18.99-70.87h70.86l-18.98 70.87h70.86l-18.99 70.87h-70.86l-18.99 70.86h94.49l19.63-73.28c10.82-40.37 47.41-68.45 89.21-68.45h118.11l-37.98 141.73h47.25l37.97-141.73h70.87l-9.49 35.43 33.11-35.43h94.49l-37.98 141.73h70.87l-66.23 70.87h-94.49l37.98-141.73h-47.25l-37.98 141.73h-70.86l9.49-35.44-33.11 35.44h-69.31a19.316 19.316 0 0 1-18.83-23.64l-29.97 23.64h-23.63c-16.9 0-32.85-7.86-43.14-21.28a54.3 54.3 0 0 1-10.23-22.71l-41.11 43.99h-70.87a54.35 54.35 0 0 1-43.14-21.28 54.39 54.39 0 0 1-9.39-47.17zm236.22 0-18.99 70.86h47.25l18.98-70.86zM1889.41 1500l-25.31 94.49h-70.87l44.31-165.36h188.97l-18.98 70.87zm-41.36 330.71h-236.22l18.98-70.87h236.22l56.97-212.6a54.392 54.392 0 0 1 52.53 68.45l-39.28 146.57c-10.82 40.37-47.4 68.45-89.2 68.45m798.51-70.87-18.99 70.87h-685.04l18.99-70.87z"
          transform="matrix(.49804 0 0 .49804 -528.303 -271.765)"
        ></path>
      </g>
    </StyledNav.Logo>
  );
};

export default LogoStan;
